const init_devices = {
  FAssetID: {
    value: "",
    label: "Device ID",
    placeholder: "Device ID",
  },
  FIMEI: {
    value: "",
    label: "IMEI",
    placeholder: "IMEI ID",
  },
  FAssetTypeID: {
    value: "",
    label: "Asset Type ID",
    placeholder: "Asset Type ID",
  },
  FSIMNumber: {
    value: "",
    label: "Sim Card No",
    placeholder: "Sim Card No",
  },
  FVehicleName: {
    value: "",
    label: "Vehicle Reg",
    placeholder: "Vehicle Reg",
  },
  FDescription: {
    value: "",
    label: "Description",
    placeholder: "Description",
  },
  Fmac_address: {
    value: "",
    label: "MAC Address",
    placeholder: "MAC Address",
  },
  Ffguid: {
    value: "",
    label: "FGUID",
    placeholder: "FGUID",
  },
  FDeviceDeactivation: {
    value: [],
    label: "Device Deactivation",
    placeholder: "Device Deactivation",
  },
  FDeviceTypeID: {
    value: "",
    label: "Device Type ID",
    placeholder: "Device Type ID",
  },
  FVehicleDevices: {
    value: [],
    label: "Vehicle Devices",
    placeholder: "Vehicle Devices",
  },
};

export default init_devices;
